/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPenaltiesDetailsQuery } from '../../models/get-penalties-details-query';
import { GetPenaltiesDetailsQueryResult } from '../../models/get-penalties-details-query-result';

export interface ApiPenaltyDetailsGetPenaltiesDetailsPost$Params {
      body?: GetPenaltiesDetailsQuery
}

export function apiPenaltyDetailsGetPenaltiesDetailsPost(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsGetPenaltiesDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsGetPenaltiesDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPenaltiesDetailsQueryResult>;
    })
  );
}

apiPenaltyDetailsGetPenaltiesDetailsPost.PATH = '/api/PenaltyDetails/GetPenaltiesDetails';
